import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Rest } from '../../../../../../../rest/rest_client';
import { NotificationsService } from '../../../../../../../services/notifications-service/notifications.service';
import { I18nService } from '../../../../../../../services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../../../../../core/services/authentication/authentication.service';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { WorkshopService } from '../../../../../services/table-management/workshop.service';
@Component({
  selector: 'app-workshop-form',
  templateUrl: './workshop-form.component.html',
  styleUrls: ['./workshop-form.component.css'],
  providers:[WorkshopService],
  standalone: false,
})
export class WorkshopFormComponent extends EntityFormComponent<Rest.InvWorkshop> implements OnInit {

  active: boolean;
  title: string;
  formManipulation: boolean;
  disableGranted: boolean;

  constructor(
    private workshopService: WorkshopService,
    notificationsService: NotificationsService,
    protected i18n: I18nService,
    private authenticationService: AuthenticationService,
    public translateService: TranslateService,
  ) {
    super(workshopService, notificationsService, i18n, authenticationService);
  }

  /**
   * Loads and evaluates all the necessary data before showing the form.
   *
   * @memberof AccessoryFormComponent
   */
  beforeShow() {
    this.setPermissions();
    this.active = !this.entity.disabled;

    if (this.isNew) {
      this.title = this.translateService.instant('tableManagement.sinister.workshop.createWorkshop');
    } else {
      this.title = this.translateService.instant('tableManagement.sinister.workshop.updateWorkshop');
    }
  }

  setPermissions() {
    const user = this.authenticationService.user;
    const rolesForForm = ['INV_WORKSHOP_CREATE', 'INV_WORKSHOP_UPDATE'];

    this.formManipulation = this.authenticationService.isOneRoleGranted(rolesForForm, user);
    this.disableGranted = this.authenticationService.isRoleGranted("INV_WORKSHOP_DISABLE", user);

  }

}

